export const noop = () => {};

export const noopHook = () => [];

export const noopPromise = () => Promise.resolve();
